// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://cloud.typography.com/6161932/6808392/css/fonts.css);"]);
// Module
exports.push([module.id, "html {\n  box-sizing: border-box;\n\n  body {\n    font-size: 100%;\n    margin: 0;\n    padding: 0;\n    color: black;\n    font-family: 'Gotham A', 'Gotham B', Helvetica, Arial, sans-serif;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
